export default "__VITE_ASSET__DEdcPZuE__"